import { axiosClient } from "services/axios";

import { AddStoreParams, EditStoreParams } from "../types";

export function addStore(params: AddStoreParams) {
  return axiosClient.post("stores/", params);
}

export function editStore(params: EditStoreParams) {
  return axiosClient.put("stores/", params);
}
